
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
        <div className="flex items-center">
          <img 
            src="https://public.readdy.ai/ai/img_res/0a5ca9e8-83ef-4625-8fdc-b7d6afb47e62.png" 
            alt="EL DORADO S.R.L." 
            className="h-12 w-auto"
          />
        </div>
        
        <div className="flex items-center gap-10">
          <button
            onClick={() => scrollToSection('home')}
            className={`text-sm font-medium tracking-wider uppercase transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-800 hover:text-blue-600' : 'text-white hover:text-blue-300'
            }`}
          >
            HOME
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className={`text-sm font-medium tracking-wider uppercase transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-800 hover:text-blue-600' : 'text-white hover:text-blue-300'
            }`}
          >
            ABOUT
          </button>
          <button
            onClick={() => scrollToSection('vpn-services')}
            className={`text-sm font-medium tracking-wider uppercase transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-800 hover:text-blue-600' : 'text-white hover:text-blue-300'
            }`}
          >
            VPN SERVICES
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`text-sm font-medium tracking-wider uppercase transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-800 hover:text-blue-600' : 'text-white hover:text-blue-300'
            }`}
          >
            CONTACT
          </button>
        </div>
      </div>
    </nav>
  );
}
